export default "__VITE_ASSET__070ba9f1__"